export interface DocumentWithS3Info {
  s3Bucket?: string | null;
  s3Path?: string | null;
}

/**
 * Constructs a CDN URL for a document based on its S3 bucket and path.
 *
 * @param doc - Object containing s3Bucket and s3Path fields
 * @param cdnHost - The CDN host (e.g., "cdn.atmts.io" or "cdn.dev.atmts.io")
 * @returns The full document URL or null if s3Bucket or s3Path is missing
 */
export function getDocumentUrl(doc: DocumentWithS3Info, cdnHost?: string): string | null {
  if (!doc.s3Bucket || !doc.s3Path) {
    return null;
  }

  // Use provided cdnHost or fall back to environment variable
  const host = cdnHost || process.env.REACT_APP_CDN_HOST;

  if (!host) {
    console.warn("CDN host not configured. Set REACT_APP_CDN_HOST or provide cdnHost parameter.");
    return null;
  }

  // Construct the URL: https://{cdnHost}/{s3Path}
  return `https://${host}/${doc.s3Path}`;
}
